import store from 'app/store/index';
export const getAssetsAttributValues = (state = store.getState(), attribut) => {
    return state.assetsCustomAttributValues.resources[attribut];
};
